import { FormattedMessageTemplate } from "@idw-types/data/message-template";

export enum MessageTemplateDetailsActionTypes {
    // Message Template Details
    SET_MESSAGE_TEMPLATE_DETAILS_LOADING = "SET_MESSAGE_TEMPLATE_DETAILS_LOADING",
    SET_MESSAGE_TEMPLATE_DETAILS = "SET_MESSAGE_TEMPLATE_DETAILS"
}

// Message Template Details
type SetMessageTemplateDetailsLoadingAction = {
    type: MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setMessageTemplateDetailsLoading = (isLoading: boolean): SetMessageTemplateDetailsLoadingAction => ({
    type: MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetMessageTemplateDetailsAction = {
    type: MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS,
    payload: { messageTemplate: FormattedMessageTemplate; }
}

export const setMessageTemplateDetails = (messageTemplate: FormattedMessageTemplate): SetMessageTemplateDetailsAction => ({
    type: MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS,
    payload: { messageTemplate }
});


export type MessageTemplateDetailsActions =
    // Message Template Details
    SetMessageTemplateDetailsLoadingAction |
    SetMessageTemplateDetailsAction